<template>
    <div>
        <v-card>
            <v-card-title class="pb-0 headline">Filtro de notificaciones</v-card-title>
            <v-card-text class="pt-0">
                <v-flex xs12 sm12>
                    <v-alert
                        v-model="showErrorDataLoadedAlert"
                        type="error"
                        dismissible
                        transition="scale-transition"
                        dark
                    >
                        No se han podido cargar todos los datos necesarios para este filtro.
                        <br />
                        Intente cargar el filtro nuevamente.
                    </v-alert>

                    <template>
                        <v-container style="max-width: 500px" class="pa-1">
                            <v-autocomplete
                                v-model="selectedCampos"
                                class="pt-0"
                                :items="inputs"
                                item-value="text"
                                return-object
                                hide-selected
                                placeholder="Selecciones los campos para filtrar..."
                                multiple
                                persistent-hint
                                deletable-chips
                                small-chips
                                dense
                                clearable
                                tags
                                ref="selectedCamposRef"
                            >
                            </v-autocomplete>

                            <v-divider></v-divider>

                            <v-flex class="my-1" align="center">
                                <v-layout>
                                    <v-fade-transition leave-absolute>
                                        <strong class="mx-4 my-1 black--text">
                                            Filtros: {{ selectedCampos.length }}
                                        </strong>
                                    </v-fade-transition>
                                    <v-fade-transition leave-absolute>
                                        <strong class="mx-4 my-1 green--text"> Activos: {{ activeFilters }} </strong>
                                    </v-fade-transition>

                                    <v-spacer></v-spacer>

                                    <v-btn color="success" small class="my-0" @click="applyFilter()">
                                        Aplicar
                                    </v-btn>
                                </v-layout>
                            </v-flex>

                            <v-divider class="mb-4"></v-divider>

                            <v-card v-if="selectedCampos.length > 0">
                                <v-list>
                                    <v-slide-y-transition class="py-0" group tag="v-list">
                                        <template v-for="(campo, i) in selectedCampos">
                                            <v-divider v-if="i !== 0" :key="`${i}-divider`" class="pb-0"></v-divider>
                                            <v-list-tile :key="campo.id">
                                                <v-list-tile-action>
                                                    <v-checkbox
                                                        v-model="campo.activo"
                                                        :disabled="selectedCampos[i].value.length === 0"
                                                        color="info"
                                                        class="mt-3"
                                                    >
                                                    </v-checkbox>
                                                </v-list-tile-action>

                                                <v-list-tile-content>
                                                    <template v-if="campo.text === 'Estado lectura'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="[
                                                                { text: 'Sin leer', value: 2 },
                                                                { text: 'Leída', value: 1 }
                                                            ]"
                                                            label="Estado lectura"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else>
                                                        <v-text-field
                                                            v-model="selectedCampos[i].value"
                                                            :label="campo.text"
                                                            autofocus
                                                            class="mt-3"
                                                        >
                                                        </v-text-field>
                                                    </template>
                                                </v-list-tile-content>

                                                <v-spacer></v-spacer>

                                                <v-scroll-x-transition>
                                                    <v-icon v-if="campo.activo" color="success">
                                                        fa-check
                                                    </v-icon>
                                                </v-scroll-x-transition>
                                            </v-list-tile>
                                        </template>
                                    </v-slide-y-transition>
                                </v-list>
                            </v-card>
                        </v-container>
                    </template>
                </v-flex>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Util from "@/util"

export default {
    name: "CustomFilterUserNotificacion",
    props: {
        internalState: { type: Object, default: null }
    },
    data: () => ({
        inputs: Util.UserNotificacionCampos(),
        selectedCampos: [],

        //saber si se cargaron todos los datos necesarios para seleccionar
        showErrorDataLoadedAlert: false
    }),
    methods: {
        applyFilter() {
            let customFilter = ""
            this.selectedCampos.forEach(campo => {
                if (campo.activo) {
                    customFilter = customFilter + `${campo.attribute}=${campo.value}&`
                }
            })
            customFilter = customFilter.slice(0, -1)
            return this.$emit("applyFilter", {
                customFilter: customFilter,
                activeFilters: this.activeFilters,
                inputs: this.inputs,
                selectedCampos: this.selectedCampos
            })
        },

        getCategoriaValue(categoria) {
            if (categoria) {
                return Util.getNotificationCategorie(null, categoria)
            } else return " "
        }
    },

    computed: {
        activeFilters() {
            return this.selectedCampos.filter(campo => campo.activo).length
        }
    },

    watch: {
        selectedCampos() {
            setTimeout(() => {
                this.$refs.selectedCamposRef.isMenuActive = false
            }, 50)
        }
    },

    mounted() {
        if (this.internalState) {
            this.selectedCampos = this.internalState.selectedCampos
            this.inputs = this.internalState.inputs
        }
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}
</style>
